export default "__VITE_ASSET__85471a24__"